import React, { useState } from "react";
import StartScreen from "./StartScreen";
import "./QrApp.css";

export default function QrApp() {
  const [showPopup, setShowPopup] = useState(true);
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    // Validazione input
    if (!inputValue.trim()) {
      setError("Inserisci un codice");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      // Chiama l'API di verifica
      const response = await fetch('/api/verify-code', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code: inputValue.trim() })
      });

      if (!response.ok) {
        throw new Error('Errore del server');
      }

      const data = await response.json();

      if (data.valid) {
        // Codice corretto
        setShowPopup(false);
        setError("");
        
        // Opzionale: salva lo stato di autenticazione
        sessionStorage.setItem('authenticated', 'true');
      } else {
        // Codice errato
        setError("Codice non valido");
        setInputValue(""); // Opzionale: pulisci l'input
      }
    } catch (error) {
      // Errore di rete o server
      console.error('Errore nella verifica:', error);
      setError("Errore di connessione. Riprova.");
    } finally {
      setIsLoading(false);
    }
  };

  // Opzionale: controlla se già autenticato
  React.useEffect(() => {
    const isAuthenticated = sessionStorage.getItem('authenticated') === 'true';
    if (isAuthenticated) {
      setShowPopup(false);
    }
  }, []);

  // Gestione Enter sulla tastiera
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !isLoading) {
      handleConfirm();
    }
  };

  return (
    <div className="qr-root">
      {showPopup ? (
        <div className="popup-overlay">
          <div className="popup">
            <h2>Inserisci il codice</h2>
            <input
              type="text" 
              className={error ? "input-error" : ""}
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
                setError(""); // cancella errore mentre scrivi
              }}
              onKeyPress={handleKeyPress}
              placeholder="Scrivi qui..."
              disabled={isLoading}
              autoFocus
            />
            {error && <p className="error-text">{error}</p>}
            <button 
              onClick={handleConfirm} 
              disabled={isLoading}
            >
              {isLoading ? "Verifica..." : "Conferma"}
            </button>
          </div>
        </div>
      ) : (
        <StartScreen
          onUploadClick={() => console.log("Carica immagini")}
          onAlbumClick={() => console.log("Visualizza album")}
        />
      )}
    </div>
  );
}